import { useCallback, useEffect, useState } from "react"
import axiosInstance from "../utils/axiosInstance"
import { API_ENDPOINTS } from "../constants/config"

const defaultConfig = {
  permissions: {
    canRead: true,
    canIssue: true,
    canPurchase: true,
    canEdit: true,
    canHistory: true,
    canAnalytics: true,
  },
  buttons: {
    showAddItem: true,
    showEditItem: true,
    showPurchase: true,
    showIssue: true,
    showAdjust: true,
    showHold: true,
    showUnhold: true,
  },
}

export default function useInventoryUiConfig() {
  const [config, setConfig] = useState(defaultConfig)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const fetchConfig = useCallback(async () => {
    try {
      setLoading(true)
      setError("")
      const response = await axiosInstance.get(API_ENDPOINTS.inventoryUiConfig)
      const nextConfig = response?.data?.data
      if (nextConfig) {
        setConfig(nextConfig)
      } else {
        setConfig(defaultConfig)
      }
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "Failed to load inventory UI config")
      setConfig(defaultConfig)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchConfig()
  }, [fetchConfig])

  return { config, loading, error, refetch: fetchConfig }
}
